import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-check-in-status',
  templateUrl: './check-in-status.component.html',
  styleUrls: ['./check-in-status.component.css']
})
export class CheckInStatusComponent implements OnInit {
    argType;

    argValue;

    viewType;

    public setting?: Setting;

    public itemsListCheckInStatuses: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
        this.viewType = this.stateService.getStateParams()['viewtype'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue && !!this.viewType) {
            this.setting = (await this.datatask.Post(1511, {
                argtype: this.argType,
                argvalue: this.argValue,
                viewtype: this.viewType
            }))[0];
        }
    }

    private async loadCheckInStatuses(): Promise<void> {
        if (!!this.setting) {
            this.itemsListCheckInStatuses = await this.datatask.Post(508, {
                argtype: this.setting?.argtype,
                argvalue: this.setting?.argvalue,
                viewtype: this.setting?.viewtype
            });
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCheckInStatuses();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    searchtext: string;
    argtype: string;
    argvalue: number;
    viewtype: string;
}
